var map = {
	"./1.1.png": "9c92",
	"./1.2.png": "21b4",
	"./1.3.png": "9deb",
	"./1.4.png": "9c13",
	"./1.5.png": "f366",
	"./1.png": "b6f4",
	"./2.1.png": "d4c7",
	"./2.11.png": "c237",
	"./2.12.png": "f919",
	"./2.13.png": "e44c",
	"./2.14.png": "7755",
	"./2.2.png": "ce94",
	"./2.png": "610b",
	"./3.1.png": "9748",
	"./3.png": "49f4",
	"./4.0.png": "2bdc",
	"./4.00.png": "412b",
	"./4.1.png": "c8e4",
	"./4.2.png": "3d20",
	"./4.3.png": "d728",
	"./4.png": "fed0",
	"./5.1.png": "e8e2",
	"./5.png": "d98e",
	"./6.1.png": "e87a",
	"./6.png": "21d0",
	"./Icon.png": "34c1",
	"./arrow1.png": "68a3",
	"./arrow2.png": "3938",
	"./game1.1.png": "9302",
	"./game1.2.png": "68b0",
	"./game1.3.png": "090c",
	"./game1.png": "df28",
	"./game2.1.png": "7bbf",
	"./game2.2.png": "afbc",
	"./game2.3.png": "6768",
	"./game2.png": "968f",
	"./game3.1.png": "b536",
	"./game3.2.png": "c931",
	"./game3.3.png": "10e0",
	"./game3.png": "a9eb",
	"./game4.1.png": "50e4",
	"./game4.2.png": "989a",
	"./game4.3.png": "b343",
	"./game4.png": "dc1d",
	"./game5.1.png": "4a5e",
	"./game5.2.png": "6d36",
	"./game5.3.png": "1f6a",
	"./game5.png": "a992",
	"./game6.1.png": "f257",
	"./game6.png": "e20f",
	"./logo.png": "3be6",
	"./star1.png": "9661",
	"./star2.png": "7ea8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "985e";